import { render, staticRenderFns } from "./Fixed-Right-Button.vue?vue&type=template&id=38085b28&"
import script from "./Fixed-Right-Button.vue?vue&type=script&lang=js&"
export * from "./Fixed-Right-Button.vue?vue&type=script&lang=js&"
import style0 from "./Fixed-Right-Button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports